import React from 'react'
import { Table, Menu, ActionIcon, Anchor, Text, Box, Flex, Avatar } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash, IconInfoCircle, IconPrinter, IconBrandWhatsapp, IconShare } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

const ActionMenu = ({ handleAction }) => {
  return (
    <Menu width={170} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          leftSection={<IconInfoCircle stroke={1.5} size={14} />}
          onClick={() => handleAction('detail')}
          fw='600'
          fz={11}
        >
          Detail
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPrinter stroke={1.5} size={14} />}
          onClick={() => handleAction('print')}
          fw='600'
          fz={11}
        >
          Print
        </Menu.Item>
        <Menu.Item
          leftSection={<IconBrandWhatsapp stroke={1.5} size={14} />}
          onClick={() => handleAction('broadcast')}
          fw='600'
          fz={11}
        >
          Broadcast WA to Internal Group
        </Menu.Item>
        <Menu.Item
          leftSection={<IconShare stroke={1.5} size={14} />}
          onClick={() => handleAction('share')}
          fw='600'
          fz={11}
        >
          Share Tracking Link
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderPackageShipmentTable = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()
  
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {

    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }

    const mappingHandleShipping = (value) => {
      if (value.supplier_id !== null || value.warehouse_id !== null) {
        return (
          <Flex justify='space-between' align='center'>
            <Flex gap={6} align='center'>
              <Avatar variant='filled' name={value.supplier_id !== null ? value.supplier.name : value.warehouse.name} radius="xl" size="sm" color='red' />
              <Text fz={13} fw='600' lineClamp={2}>{value.supplier_id !== null ? value.supplier.name : value.warehouse.name}</Text>
            </Flex>
            <Flex gap={2} align='center'>
              <ActionIcon variant="transparent" size={23} color='blue' radius="xs" onClick={() => actionMethod(value, 'handle_shipping')}>
                <IconPencil style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
              <ActionIcon variant="transparent" size={23} radius="xs" onClick={() => actionMethod(value, 'remove_handling_shipping')}>
                <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
            </Flex>
          </Flex>
        )
      } else {
        return (
          <Flex justify='space-between' align='center'>
            <Text fz={13} c='red'>No One</Text>
            <ActionIcon variant="transparent" size={23} color='blue' radius="xs" onClick={() => actionMethod(value, 'handle_shipping')}>
              <IconPencil style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Flex>
        )
      }
    }

    const mappingPackageDocument = (value) => {
      if (value.documents !== null) {
        return (
          <Flex justify='space-between' align='center'>
            <Text fz={13} fw='600' lineClamp={2}>{value.documents.name}</Text>
            <ActionIcon variant="transparent" size={23} radius="xs" onClick={() => actionMethod(value, 'remove_shipping_document')}>
              <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Flex>
        )
      } else {
        return (
          <Flex justify='space-between' align='center'>
            <Text fz={13} c='red'>No Documents</Text>
            <ActionIcon variant="transparent" size={23} color='blue' radius="xs" onClick={() => actionMethod(value, 'shipping_document')}>
              <IconPencil style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Flex>
        )
      }
    }

    const openTrackingUrl = (trackCode) => {
      if (trackCode !== null) {
        window.open(`https://tracking.asiacommerce.net/number/${trackCode}`, '_blank')
      }
    }

    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.name}</Table.Td>
        <Table.Td>
          <Box>
            <Text fz={13} mb={14}>{val.courier_name}</Text>
            <Box>
              <Text fz={13}>Tracking: </Text>
              <Anchor fz={13} underline="hover" c={val.tracking_code !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => openTrackingUrl(val.tracking_code)}>{val.tracking_code !== null ? val.tracking_code : '-'}</Anchor>
            </Box>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Text fz={13} mb={14}>{val.last_mile_courier || '-'}</Text>
            <Box>
              <Text fz={13}>Tracking: </Text>
              <Text fz={13}>{val.tracking_code_courier || '-'}</Text>
            </Box>
          </Box>
        </Table.Td>
        <Table.Td>
          {mappingHandleShipping(val)}
        </Table.Td>
        <Table.Td>
          {mappingPackageDocument(val)}
        </Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.creator !== null ? val.creator.name : 'Created By System'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.updater !== null ? val.updater.name : 'Unknown User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.updated_at).format('DD/MMMM/YYYY')} - { dayjs(val.updated_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderPackageShipmentTable